import React from "react";
import Input from "../../../components/form-components/Input";
import { WizardCard, WizardSection, selectCls } from "./WizardUI";

// Step 1 (spec §3.1): name + purpose are both required — deliberately no
// auto-generated "<Template> copy" default (unlike the old CustomRoleEditor
// create path, which seeded "<Template> (Custom)"). `templateOptions` lets an
// admin who arrived without a seeded template (RolesCatalogPage's "New
// organisation role", vs a template's own "Use template" action) still pick
// one as this role's capability/governance baseline, or start from scratch.
export default function StepNamePurpose({
  name,
  setName,
  purpose,
  setPurpose,
  cloneCode,
  setCloneCode,
  templateOptions,
}) {
  return (
    <WizardCard title="Name & purpose" subtitle="Give this role a meaningful name and describe what it's for.">
      <div className="space-y-4">
        <WizardSection title="Name" helperText="Shown throughout the app wherever roles are listed. Required.">
          <Input
            name="wizard-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. Product Finance Manager"
            noMarginBottom
          />
        </WizardSection>

        <WizardSection title="Purpose" helperText="Plain-language explanation of what this role is for. Required.">
          <Input
            name="wizard-purpose"
            type="text"
            value={purpose}
            onChange={(e) => setPurpose(e.target.value)}
            placeholder="e.g. Prepares and submits budgets for the EU product line."
            noMarginBottom
          />
        </WizardSection>

        <WizardSection
          title="Start from a template"
          helperText="Optional. Seeds this role's capabilities as a starting point for the next steps — you can still start from scratch."
        >
          <select
            aria-label="Start from a template"
            value={cloneCode}
            onChange={(e) => setCloneCode(e.target.value)}
            className={selectCls}
          >
            <option value="">Start from scratch</option>
            {templateOptions.map((r) => (
              <option key={r.code} value={r.code}>
                {r.name}
              </option>
            ))}
          </select>
        </WizardSection>
      </div>
    </WizardCard>
  );
}
